export const encodeUsernameForCognito = (username: string): string => {
  if (!username) return username;
  return username.replace(/\s/g, "&nbsp;");
};

export const decodeUsernameForDisplay = (
  username: string | undefined | null,
): string => {
  if (!username) return username || "";
  return username.replace(/&nbsp;/g, " ");
};
